import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { fetchCompanyMemberDetails } from "@store/members/members-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { useEffect, useState } from "react";

/**
 * Fetches a member of the workspace again, since what the user did meanwhile may have changed
 * their workspace role. The member is updated in the store, and kept as known so far when fetching
 * failed, which the errors slice tells the user about.
 *
 * @param memberIdentity The identity of the member
 * @returns whether the member is still being fetched
 */
export function useRefetchMember(memberIdentity) {
  const $ = _c(5);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const [isLoading, setIsLoading] = useState(true);
  let t0;
  let t1;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== memberIdentity) {
    t0 = () => {
      const request = dispatch(fetchCompanyMemberDetails({
        companyId,
        identity: memberIdentity
      }));
      request.finally(() => setIsLoading(false));
      return () => request.abort();
    };
    t1 = [companyId, dispatch, memberIdentity];
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = memberIdentity;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return isLoading;
}